import "./landing.css";

const FooterSection = () => {

  return (
    <footer className="footer">
      <span>© 2025 SignalFly Global • Built for serious traders</span>
    </footer>
  );
};

export default FooterSection;
